import ReactDOM from "react-dom"
import language from "lang/langSetting"
import preval from "preval.macro"

import AppRoute from "./AppRoute"

import "./style.scss"

console.log(
  [
    preval`module.exports = process.env.CI_COMMIT_REF_NAME || process.env.GIT_BRANCH`,
    new Date(preval`module.exports = new Date()`).toLocaleString("zh", "Asia/Taipei"),
    preval`module.exports = process.env.CI_COMMIT_SHA || process.env.GIT_COMMIT`,
  ].join("\n"),
)

language().then(() => {
  ReactDOM.render(<AppRoute />, document.getElementById("root"))
})

window.addEventListener("error", (e) => {
  // when webpack loading chunk failed, usually it means there is a newer version deployed
  if (
    /Loading(\sCSS)? chunk [\d]+ failed/.test(e.message) &&
    sessionStorage.getItem("webpackChunkError") !== e.message
  ) {
    // record to prevent an infinite loop when still fail to load chunk after reloading
    sessionStorage.setItem("webpackChunkError", e.message)
    window.location.reload()
  }
})

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV === "development" && process.env.REACT_APP_MOCK) {
      const { worker } = require("./test/msw/browser")
      worker.start()
      return // skip other worker
    }

    navigator.serviceWorker.register("/updateWorker.js").then(
      function (registration) {
        console.log("ServiceWorker registration successful with scope: ", registration.scope)
      },
      function (err) {
        console.log("ServiceWorker registration failed: ", err)
      },
    )
  })
}
